var CarouselComplex;
(function (CarouselComplex) {
    __once('.paragraph--type--hero-card-complex-cards', () => {
        var _a, _b;
        const $carousel = document.querySelector('.carousel.component.paragraph--type--hero-card-complex-cards');
        if ($carousel) {
            const $glide = $carousel.querySelector('.glide');
            const $bullets = $glide.querySelector('.glide__bullets');
            const $slideWrapper = $glide.querySelector('.glide__slides');
            const $slides = $slideWrapper.querySelectorAll('.paragraph');
            const $bullet = $glide.querySelector('.glide__bullet');
            $slides.forEach(($slide) => {
                $slide.classList.add('glide__slide');
            });
            const glideController = new Glide($glide, {
                type: 'slider',
                focusAt: 0,
                perView: 3,
                rewind: false,
                bound: true,
                animationDuration: 600,
                animationTimingFunc: 'linear',
                keyboard: true,
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    570: {
                        perView: 1
                    }
                }
            });
            $slides.forEach(($slide, index) => {
                const $navControl = $bullet.cloneNode(true);
                $navControl.setAttribute('data-glide-dir', `=${index}`);
                $navControl.classList.remove('hidden');
                $bullets.appendChild($navControl);
            });
            glideController.mount();
            glideController.pause();
            $carousel.classList.add('is-initialized');
            (_a = $glide.querySelector('.glide__arrow--left')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-label', 'Scorri a sinistra');
            (_b = $glide.querySelector('.glide__arrow--right')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', 'Scorri a destra');
            $carousel['glideController'] = glideController;
            gliderArrowsEvent($glide);
        }
    });
})(CarouselComplex || (CarouselComplex = {}));
var CarouselSimple;
(function (CarouselSimple) {
    __once('.paragraph--type--carousel', () => {
        var _a, _b;
        const $carousel = document.querySelector('.carousel.component.paragraph--type--carousel');
        if ($carousel) {
            const $glide = $carousel.querySelector('.glide');
            const $bullets = $glide.querySelector('.glide__bullets');
            const $slideWrapper = $glide.querySelector('.glide__slides');
            const $slides = $slideWrapper.querySelectorAll('.paragraph');
            const $bullet = $glide.querySelector('.glide__bullet');
            $slides.forEach(($slide) => {
                $slide.classList.add('glide__slide');
            });
            const glideController = new Glide($glide, {
                type: 'slider',
                focusAt: 0,
                perView: 4,
                rewind: false,
                bound: true,
                animationDuration: 600,
                animationTimingFunc: 'linear',
                keyboard: true,
                breakpoints: {
                    1024: {
                        perView: 3
                    },
                    800: {
                        perView: 2
                    },
                    570: {
                        perView: 1
                    }
                }
            });
            $slides.forEach(($slide, index) => {
                const $navControl = $bullet.cloneNode(true);
                $navControl.setAttribute('data-glide-dir', `=${index}`);
                $navControl.classList.remove('hidden');
                $bullets.appendChild($navControl);
            });
            glideController.mount();
            glideController.pause();
            $carousel.classList.add('is-initialized');
            (_a = $glide.querySelector('.glide__arrow--left')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-label', 'Scorri a sinistra');
            (_b = $glide.querySelector('.glide__arrow--right')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', 'Scorri a destra');
            $carousel['glideController'] = glideController;
            gliderArrowsEvent($glide);
        }
    });
})(CarouselSimple || (CarouselSimple = {}));
var CarouselNews;
(function (CarouselNews) {
    __once('.news-list-carousel', () => {
        var _a, _b;
        const $carousel = document.querySelector('.news-list-carousel');
        if ($carousel) {
            const $glide = $carousel.querySelector('.glide');
            const $bullets = $glide.querySelector('.glide__bullets');
            const $slideWrapper = $glide.querySelector('.glide__slides');
            const $slides = $slideWrapper.querySelectorAll('.views-row');
            const $bullet = $glide.querySelector('.glide__bullet');
            $slides.forEach(($slide) => {
                $slide.classList.add('glide__slide');
            });
            $slides.forEach(($slide, index) => {
                const $navControl = $bullet.cloneNode(true);
                $navControl.setAttribute('data-glide-dir', `=${index}`);
                $navControl.classList.remove('hidden');
                $bullets.appendChild($navControl);
            });
            const glideController = new Glide($glide, {
                type: 'slider',
                focusAt: 0,
                perView: 3,
                rewind: false,
                bound: true,
                animationDuration: 600,
                animationTimingFunc: 'linear',
                gap: 0,
                keyboard: true,
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    570: {
                        perView: 1
                    }
                }
            });
            glideController.mount();
            glideController.pause();
            $carousel.classList.add('is-initialized');
            (_a = $glide.querySelector('.glide__arrow--left')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-label', 'Scorri a sinistra');
            (_b = $glide.querySelector('.glide__arrow--right')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', 'Scorri a destra');
            $carousel['glideController'] = glideController;
            gliderArrowsEvent($glide);
        }
    });
})(CarouselNews || (CarouselNews = {}));
var HeroCarousel;
(function (HeroCarousel) {
    __once("search", () => {
        const $heroes = document.querySelectorAll('.hero-carousel.component');
        $heroes.forEach(($hero) => {
            var _a, _b;
            const $glide = $hero.querySelector('.glide');
            const $slides = $glide.querySelectorAll('.glide__slide');
            const $bullets = $glide.querySelector('.glide__bullets');
            const $bullet = $glide.querySelector('.glide__bullet');
            const glideController = new Glide($glide, {
                type: 'slider',
                focusAt: 'center',
                perView: 1,
                gap: 30,
                autoplay: false,
                animationDuration: 600,
                animationTimingFunc: 'linear',
                keyboard: true,
                rewind: false,
                breakpoints: {
                    800: {
                        perView: 1,
                        peek: {
                            before: 0,
                            after: 0
                        },
                    }
                }
            });
            $slides.forEach(($slide, index) => {
                const $navControl = $bullet.cloneNode(true);
                $navControl.setAttribute('data-glide-dir', `=${index}`);
                $navControl.classList.remove('hidden');
                $bullets.appendChild($navControl);
            });
            glideController.mount();
            glideController.pause();
            $hero['glideController'] = glideController;
            $hero.classList.add('is-initialized');
            (_a = $glide.querySelector('.glide__arrow--left')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-label', 'Scorri a sinistra');
            (_b = $glide.querySelector('.glide__arrow--right')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', 'Scorri a destra');
        });
        $heroes.forEach(hero => {
            gliderArrowsEvent(hero);
        });
    });
})(HeroCarousel || (HeroCarousel = {}));
var CarouselTab;
(function (CarouselTab) {
    __once('.paragraph--type--carousel', () => {
        var _a, _b;
        const $carousel = document.querySelector('.component.paragraph--type--tab');
        if ($carousel) {
            const $glide = $carousel.querySelector('.glide');
            const $bullets = $glide.querySelector('.glide__bullets');
            const $slideWrapper = $glide.querySelector('.glide__slides');
            const $slides = $slideWrapper.querySelectorAll('.paragraph');
            const $bullet = $glide.querySelector('.glide__bullet');
            $slides.forEach(($slide) => {
                $slide.classList.add('glide__slide');
            });
            const glideController = new Glide($glide, {
                type: 'slider',
                focusAt: 0,
                perView: 8,
                rewind: false,
                bound: true,
                animationDuration: 600,
                animationTimingFunc: 'linear',
                keyboard: true,
                breakpoints: {
                    1024: {
                        perView: 7
                    },
                    800: {
                        perView: 5
                    },
                    570: {
                        perView: 2
                    }
                }
            });
            $slides.forEach(($slide, index) => {
                const $navControl = $bullet.cloneNode(true);
                $navControl.setAttribute('data-glide-dir', `=${index}`);
                $navControl.classList.remove('hidden');
                $bullets.appendChild($navControl);
            });
            glideController.mount();
            glideController.pause();
            $carousel.classList.add('is-initialized');
            (_a = $glide.querySelector('.glide__arrow--left')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-label', 'Scorri a sinistra');
            (_b = $glide.querySelector('.glide__arrow--right')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', 'Scorri a destra');
            $carousel['glideController'] = glideController;
        }
    });
})(CarouselTab || (CarouselTab = {}));
function gliderArrowsEvent(gliderNode) {
    const KEY_ENTER = 'Enter';
    const arrows = gliderNode.querySelectorAll('.glide__arrow');
    arrows === null || arrows === void 0 ? void 0 : arrows.forEach(arrow => arrow.addEventListener('keydown', (event) => {
        if (event.key === KEY_ENTER) {
            arrow.click();
        }
    }));
}
